import { DynamicField } from 'shared/api/kyrgyzstan/search/model'

/**
 * Проверяет, нужно ли отображать значение поля
 * @param field - Поле динамического типа
 * @returns true, если поле имеет тип TEXT или NUMBER и имеет значение
 */
export const shouldShowFieldValue = (field: DynamicField): boolean => {
  const allowedFieldTypes: DynamicField['field_type'][] = ['TEXT', 'NUMBER']
  return allowedFieldTypes.includes(field.field_type) && !!field.value
}
